export default class MessageResources {

    private static ACTIVE_DEVICES = "Active Devices";
    private static ACTIVE_USERS = "Active Users";
    private static ASSET_NAME = "Asset Name";
    private static COUNT = "Count";
    private static DATE = "Date";
    private static INSTALLS = "Installs";
    private static NEW_DEVICES = "New Devices";
    private static NUMBER_OPENED = "Number Opened";
    private static PUSH_NOTIFICATION_TITLE = "Push Notification Title";
    private static SPONSOR_NAME = "Sponsor Name";
    private static VIEWS = "Views";

    public static getText(key:string):string {
        if (key == "activeDevices") {
            return this.ACTIVE_DEVICES;
        } else if (key == "activeUsers") {
            return this.ACTIVE_USERS
        } else if (key == "assetName") {
            return this.ASSET_NAME;
        } else if (key == "count") {
            return this.COUNT;
        } else if (key == "date") {
            return this.DATE;
        } else if (key == "installs") {
            return this.INSTALLS;
        } else if (key == "newDevices") {
            return this.NEW_DEVICES;
        } else if (key == "numberOpened") {
            return this.NUMBER_OPENED;
        } else if (key == "pushNotificationTitle") {
            return this.PUSH_NOTIFICATION_TITLE;
        } else if (key == "sponsorName") {
            return this.SPONSOR_NAME;
        } else if (key == "views") {
            return this.VIEWS;
        }

        return key;
    }
}